// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-header[data-v-7ad5bc3b]{background-color:#fff}.my-header[data-v-7ad5bc3b] .v-toolbar__content{padding-left:12px;padding-right:24px}.header[data-v-7ad5bc3b]{width:100%;margin-top:16px;justify-content:space-between}.header[data-v-7ad5bc3b],.header-left[data-v-7ad5bc3b]{display:flex;align-items:center}.header-left-icon[data-v-7ad5bc3b]{margin-right:12px;cursor:pointer}.header-left-icon[data-v-7ad5bc3b]:hover{opacity:.8}.header-left-logo[data-v-7ad5bc3b]{height:26px}", ""]);
// Exports
module.exports = exports;
